<template>
  <div id="app">
    <div class="xq_top">
      <img class="img" @click="xqesc" src="../../static/images/esc.png" />
      <p @click="xqesc">{{pickxq[pickxb].fh}}</p>
      <span>{{pickxq[pickxb].spxq}}</span>
    </div>
    <div class="ddlist">
      <div v-for="(item,index) in ddlist">
        <div class="top">
          <span style="font-size:.32rem;font-weight:bold;">{{tablelist[pickxb].ddh}}</span>
          <p v-if="item.State==1" class="on1">{{tablelist[pickxb].wc}}</p>
          <p v-if="item.State==0" class="on2">{{tablelist[pickxb].xd}}</p>
          <p v-if="item.State==2" class="on3">{{tablelist[pickxb].qx}}</p>
        </div>
        <div class="top">
          <span>{{item.SheetID}}</span>
        </div>
        <div class="but">
          <div class="butlist">
            <span v-if="tableid!='Food'">{{Desk}}</span>
            <span v-if="tableid=='Food'">{{ztlist[pickxb].o4}}<template
                v-if="number!='0'">({{number}})</template></span>
          </div>
          <div class="butlist">
            <span style="font-size:.32rem;font-weight:bold;">{{tablelist[pickxb].bz}}:</span>
          </div>
          <div class="butlist">
            <span>{{item.Remark?item.Remark:''}}{{" "}}</span>
          </div>
          <div class="butlist">
            <span style="font-size:.32rem;font-weight:bold;">{{tablelist[pickxb].xdsj}}:</span><span>{{item.OpTime}}</span>
          </div>
          <div class="butlist" v-if="item.State==2">
            <span style="font-size:.32rem;font-weight:bold;">{{tablelist[pickxb].qxyy}}:</span>
          </div>
          <div class="butlist" v-if="item.State==2">
            <span v-if="item.Failure==1">{{ztlist[pickxb].o1}}</span>
            <span v-if="item.Failure==4">{{ztlist[pickxb].o2}}</span>
            <span v-if="item.Failure==3">{{ztlist[pickxb].o3}}</span>
            <span v-if="item.Failure==11">{{ztlist[pickxb].o11}}</span>
            <span v-if="item.Failure==12">{{ztlist[pickxb].O12}}</span>
            <span v-if="item.Failure==13">{{ztlist[pickxb].O13}}({{parseInt(item.Errorcontent)+1}}min)</span>
            <span v-if="item.Failure==14">{{ztlist[pickxb].o14}}</span>
          </div>
          <div style="height:rem;display:flex;width:90%;justify-content:space-between;margin:0 auto;">
            <button v-if="item.SheetState==4&&item.State==1&&number>0"
              style="width:3rem;height:.8rem;color:green;border:1px solid green;" class="dmbt"
              @click="kxdpq(item.SheetID)">{{ztlist[pickxb].yjdd}}</button>
            <button style="width:2rem;height:.8rem;" class="dmbt" @click="hexiao(item)">{{kxdlang[pickxb].o2}}</button>
            <button style="width:2rem;height:.8rem;" class="dmbt"
              @click="dingdan(item.SheetID)">{{tablelist[pickxb].ckxq}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="bj" style="background:#f7f7f7;position:fixed;top:0;left:0;right:0;bottom:0;z-index:-1;"></div>
    <div v-show="pqsb" style="position:fixed;width:100%;height:7.2rem;left:0%;top:10%;background:orange;border-radius:1rem;">
      <div style="font-size:.48rem;line-height:1rem;">{{kxdlang[pickxb].o1}}:{{items.SheetNumbers}}</div>
      <div ref="qrcode"></div>
      <div @click="pqsb=false" style="width:2.4rem;height:.8rem;margin:.1rem auto;font-size:.36rem;border:1px solid #000;border-radius:.1rem;text-align:center;line-height:.8rem;">{{ztlist[pickxb].qd}}</div>
    </div>
  </div>
</template>

<script>
  import '../../static/js/rem.js'
  import QRCode from 'qrcode'
import { error } from 'jquery'
  export default {
    data() {
      return {
        ddxb: 0,
        ShopID: 0,
        tableid: 0,
        number: '0',
        items:{},
        pqsb:false,
        ddlist: [],
        Desk: "",
        SheetID: '',
        TradeId: '',
        PayState: '',
        PayChannel: 'yabandpay',
        PAYSTATE_YABAND: '5',
        PAYSTATE_ALLINPAY: '7',
        PAYCHANNEL_YABAND: 'yabandpay',
        PAYCHANNEL_ALLINPAY: 'allinpay',
        tablelist: [{
            nb: ['全部订单', '下单成功', '已下单', '下单失败'],
            wc: '下单成功',
            xd: '已下单',
            qx: '下单失败 ',
            ddh: '订单号',
            xdcz: '下单餐桌',
            xdsj: '下单时间',
            bz: '备注',
            ckxq: '查看详情',
            qxyy: '取消原因'
          }, //1
          {
            nb: ['全部訂單', '已完成', '已下單', '已取消'],
            wc: '已完成',
            xd: '已下單',
            qx: '已取消',
            ddh: '訂單號',
            xdcz: '下單餐桌',
            xdsj: '下單時間',
            bz: '備註',
            ckxq: '查看詳情',
            qxyy: '取消原因'
          }, //2
          {
            nb: ['Order', 'Order Completed', 'Order Placed', 'Order  Cancelled'],
            wc: 'Order Completed',
            xd: 'Order Placed',
            qx: 'Order  Cancelled',
            ddh: 'Order Number',
            xdcz: 'Order Channel',
            xdsj: 'Order Time',
            bz: 'Note',
            ckxq: 'details',
            qxyy: 'Cancellation Reason'
          }, //3
          {
            nb: ['جميع الطلبات', 'منجز', 'زائد', 'ألغيت'],
            wc: 'منجز',
            xd: 'زائد',
            qx: 'ألغيت',
            ddh: 'رقم الطلب',
            xdcz: 'طلب طاولة الطعام',
            xdsj: 'وقت الطلب',
            bz: 'ملاحظة',
            ckxq: 'تحقق من التفاصيل',
            qxyy: 'سبب الالغاء'
          }, //4
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'បានបញ្ចប់',
            xd: 'បានបញ្ជាទិញ',
            qx: 'បានលុបចោល',
            ddh: 'លេខ​លំដាប់',
            xdcz: 'តារាងបញ្ជា',
            xdsj: 'ពេលវេលាបញ្ជា',
            bz: 'ចំណាំ',
            ckxq: 'ពិនិត្យព័ត៌មានលម្អិត',
            qxyy: 'ហេតុផលសម្រាប់ការលុបចោល'
          }, //5
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //6
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //7
          {
            nb: ['Alle bestelling', 'Voltooid', 'Bestelling is geplaatst', 'Geannuleerd'],
            wc: 'Voltooid',
            xd: 'Bestelling is geplaatst',
            qx: 'Geannuleerd',
            ddh: 'Bestelling nummer',
            xdcz: 'Plaats een besteltafel',
            xdsj: 'Bestel tijd',
            bz: 'Opmerking',
            ckxq: 'Zie de details',
            qxyy: 'Reden voor annulering'
          }, //8
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //9
          {
            nb: ['completa', 'fatto', 'ordinato', 'annullato '],
            wc: 'fatto',
            xd: 'ordinato',
            qx: 'annullato ',
            ddh: "N'ordinazione",
            xdcz: 'Ordine tavolo numero',
            xdsj: "Orario ordine",
            bz: 'Note',
            ckxq: "Altre Modulo d'ordine",
            qxyy: 'Perché non vuoi più ordinare?'
          }, //10
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //11
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //12
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //13
          {
          	nb: ['Alle Bestellungen', 'Bestellung erfolgreich aufgegeben', 'Bestellung aufgegeben', 'Bestellung fehlgeschlagen'],
              wc: 'Bestellung erfolgreich aufgegeben',
              xd: 'Bestellt',
              qx: 'Bestellung fehlgeschlagen ',
              ddh: 'Bestellnummer',
              xdcz: 'Bestellter Tisch / Tischnummer',
              xdsj: 'Bestellzeit',
              bz: 'Bemerkung',
              ckxq: 'Details anzeigen',
              qxyy:'Stornierungsgrund'
          }, //14
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //15
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //16
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //17
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //18
          {
            nb: ['Wszystkie zamówienia', 'Zakończony', 'zostało złożone', 'Anulowany'],
            wc: 'Zakończony',
            xd: 'zostało złożone',
            qx: 'Anulowany',
            ddh: 'numer',
            xdcz: 'table',
            xdsj: 'Czas realizacji',
            bz: 'Uwaga',
            ckxq: 'Zobacz więcej',
            qxyy: 'Powód anulowania'
          }, //19
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //20
          {
            nb: ['All orders', 'Completed', 'Have order', 'Cancelled'],
            wc: 'completed',
            xd: 'Have order',
            qx: 'Cancelled',
            ddh: 'number',
            xdcz: 'table',
            xdsj: 'time',
            bz: 'note',
            ckxq: 'details',
            qxyy: 'Cancel the reason'
          }, //21
          {
            nb: ['ทุกออเดอร์', 'สั่งซื้อเรียบร้อยแล้ว', 'สั่งซื้อแล้ว', 'คำสั่งซื้อล้มเหลว'],
            wc: 'สั่งซื้อเรียบร้อยแล้ว',
            xd: 'สั่งซื้อแล้ว',
            qx: 'คำสั่งซื้อล้มเหลว',
            ddh: 'หมายเลขคำสั่งซื้อ',
            xdcz: 'สั่งโต๊ะ',
            xdsj: 'เวลาสั่ง',
            bz: 'หมายเหตุ',
            ckxq: 'ตรวจสอบรายละเอียด',
            qxyy: 'เหตุผลในการยกเลิก'
          }, //22
          {
            nb: ['Όλες οι παραγγελίες', 'Η παραγγελία πραγματοποιήθηκε με επιτυχία', 'Έγινε παραγγελία',
              'Η παραγγελία απέτυχε'
            ],
            wc: 'Έγινε παραγγελία',
            xd: 'Έγινε παραγγελία',
            qx: 'Η παραγγελία απέτυχε',
            ddh: 'Αριθμός παραγγελίας',
            xdcz: 'Παραγγείλετε ένα τραπέζι',
            xdsj: 'Ώρα παραγγελίας',
            bz: 'Παρατήρηση',
            ckxq: 'ελέγξτε τις λεπτομέρειες',
            qxyy: 'Λόγος ακύρωσης'
          }, //23
          {
              nb: ['Vsa naročila', 'Naročilo uspešno oddano', 'Oddano naročilo', 'Naročilo ni uspelo'],
              wc: 'Naročilo uspešno oddano',
              xd: 'Oddano naročilo',
              qx: 'Naročilo ni uspelo ',
              ddh: 'Naročilna št.',
              xdcz: 'Miza št.',
              xdsj: 'Čas naročila',
              bz: 'Opombe',
              ckxq: 'Poglej podrobnosti',
              qxyy:'Razlog za preklic'
          }, //24
		  {
			nb: ['Бүх захиалга', 'Захиалга өгсөн', 'Захиалга өгсөн', 'Захиалга амжилтгүй боллоо'],
			wc: 'Захиалга өгсөн',
			xd: 'Захиалга өгсөн',
			qx: 'Захиалга амжилтгүй боллоо',
			ddh: 'Захиалгын дугаар',
			xdcz: 'Хоолны ширээ захиал',
			xdsj: 'Захиалсан цаг',
			bz: 'Тайлбар',
			ckxq: 'дэлгэрэнгүй мэдээлли',
			qxyy: 'Цуцлах'
		  }, //25
        ],
        pickxq: [{
            fh: '返回',
            spxq: '订单详情',
            sl: '数量',
            qxzgg: '请选择规格',
            jrgwc: '加入购物车',
            yx: '已选'
          },
          {
            fh: '返回',
            spxq: '訂單詳情',
            sl: '数量',
            qxzgg: '请选择规格',
            jrgwc: '加入购物车',
            yx: '已选'
          },
          {
            fh: 'Back',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'إرجاع',
            spxq: 'تفاصيل الطلب',
            sl: 'كمية',
            qxzgg: 'الرجاء تحديد المواصفات',
            jrgwc: 'أضفها الى قائمة المشتريات',
            yx: 'المحدد'
          },
          {
            fh: 'ដកថយ',
            spxq: 'ព័ត៌មានលម្អិត',
            sl: 'បរិមាណ',
            qxzgg: 'សូមជ្រើសរើសការបញ្ជាក់',
            jrgwc: 'បន្ថែមទៅរទេះទិញទំនិញ',
            yx: 'បានជ្រើសរើស'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'Indietro',
            spxq: "Modulo d'ordine",
            sl: 'Quantità',
            qxzgg: 'Quantità ',
            jrgwc: 'Già aggiunto al carrello',
            yx: 'Già scelto'
          },
          {
            fh: '戻り',
            spxq: '情報',
            sl: '数量',
            qxzgg: '選択項目',
            jrgwc: 'カート',
            yx: '選択済み'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
            fh: 'return',
            spxq: 'The order details',
            sl: 'The number of',
            qxzgg: 'specification',
            jrgwc: 'Add to Cart',
            yx: 'The selected'
          },
          {
              fh: 'Nazaj',
              spxq: 'Podrobnosti o naročilu',
              sl: 'Količina',
              qxzgg: 'Prosimo, izberite specifikacijo(-e) ...',
              jrgwc: 'Dodajte v košarico',
              yx: 'Izbrani'
          },
          {
              fh: 'Nazaj',
              spxq: 'Podrobnosti o naročilu',
              sl: 'Količina',
              qxzgg: 'Prosimo, izberite specifikacijo(-e) ...',
              jrgwc: 'Dodajte v košarico',
              yx: 'Izbrani'
          },
          {
              fh: 'Nazaj',
              spxq: 'Podrobnosti o naročilu',
              sl: 'Količina',
              qxzgg: 'Prosimo, izberite specifikacijo(-e) ...',
              jrgwc: 'Dodajte v košarico',
              yx: 'Izbrani'
          },
          {
              fh: 'Nazaj',
              spxq: 'Podrobnosti o naročilu',
              sl: 'Količina',
              qxzgg: 'Prosimo, izberite specifikacijo(-e) ...',
              jrgwc: 'Dodajte v košarico',
              yx: 'Izbrani'
          },
          {
              fh: 'Nazaj',
              spxq: 'Podrobnosti o naročilu',
              sl: 'Količina',
              qxzgg: 'Prosimo, izberite specifikacijo(-e) ...',
              jrgwc: 'Dodajte v košarico',
              yx: 'Izbrani'
          },
        ],
        pickxb: 0,
        kxdlang:[
         {o1:"流水单号",o2:"核销码",},
         {o1:"流水單號",o2:"付款碼",},
         {o1:"Serial number",o2:"Payment code",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"Serial number",o2:"Payment code",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
         {o1:"流水单号",o2:"核销",},
        ],
        ztlist: [{
            yjdd: "确定到店",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "餐台未开台",
            o2: "餐厅未接单",
            o3: "餐台正在结账",
            o4: "外卖",
            o11: "点餐次数超过可点次数",
            O12: "点菜数量大于可点数量",
            O13: "当前时间不在可点菜范围",
            o14: "点菜时间已过请重新开台"
          },
          {
            yjdd: "確定到達",
            zwdd: "暫無訂單",
            wxts: "溫馨提示",
            qd: "確定",
            o1: "餐檯未開台",
            o2: "餐廳未接單",
            o3: "餐檯正在結賬",
            o4: "外賣",
            o11: "點餐次數超過",
            O12: "點菜數量過多",
            O13: "點菜時間還沒到",
            o14: "點餐時間已過"
          },
          {
            yjdd: "Arrive",
            zwdd: "No order yet",
            wxts: "Tips",
            qd: "Confirm",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: " أمر مؤقت ",
            wxts: " جديلة",
            qd: " أكّد ",
            o1: "لم يفتح طاولة الطعام المحطة",
            o2: "لا يتلقى المطعم أوامر",
            o3: "طاولة الطعام يتم التحقق منها",
            o4: "وجبات سريعة",
            o11: "عدد أوقات الطلب هو أكثر من عدد النقاط.",
            O12: "عدد الطلبات أكبر من عدد الطلبات",
            O13: "الوقت الحالي غير متاح للطلب",
            o14: "انتهى الوقت ، يرجى إعادة فتح"
          },
          {
            yjdd: "Arrive",
            zwdd: "ព័ត៌មាន​ជំនួយ",
            wxts: "ព័ត៌មាន​ជំនួយ",
            qd: "កំណត់",
            o1: "តុបរិភោគអាហារមិនបើកទេ។",
            o2: "ភោជនីយដ្ឋានមិនទទួលការបញ្ជាទិញ",
            o3: "តារាងបរិភោគអាហារកំពុងពិនិត្យមើល",
            o4: "អាហាររហ័ស",
            o11: "បញ្ជាទិញលើសពីការអនុញ្ញាត",
            O12: "បរិមាណបញ្ជាទិញគឺធំជាងបរិមាណបញ្ជាទិញ",
            O13: "ពេលវេលាបច្ចុប្បន្នមិនមានសម្រាប់ការបញ្ជាទិញទេ។",
            o14: "ពេលវេលាបញ្ជាទិញបានកន្លងផុតទៅហើយ សូមបើកឡើងវិញ"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "Determine",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "het aantal bestellingen overschrijdt het aantal beschikbare bestellingen",
            O12: "het aantal bestellingen is groter dan het aantal beschikbare bestellingen",
            O13: "de huidige tijd ligt niet binnen het bereik van beschikbare bestellingen",
            o14: "de besteltijd is verlopen, alstublieft heropenen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "无",
            wxts: "提示",
            qd: "確定",
            o1: "未配席",
            o2: "未受注",
            o3: "会計中",
            o4: "ファストフード",
            o11: "注文回数オーバー",
            O12: "注文点数オーバー",
            O13: "タイムアウト",
            o14: "タイムアウト"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
          {
            yjdd: "Arrive",
            zwdd: "暂无订单",
            wxts: "温馨提示",
            qd: "确定",
            o1: "Not open",
            o2: "Missed orders",
            o3: "Checking out",
            o4: "Fast Food",
            o11: "the number of orders exceeds the number of orders available",
            O12: "the number of orders is greater than the number of orders available",
            O13: "the current time is not within the range of orders available",
            o14: "the order time has expired, please reopen"
          },
        ],
        picktan: [{
            qd: "确定",
            qx: "取消",
            sfsc: "是否删除",
            jiazai: "",
            sfhj: "呼叫服务"
          },
          {
            qd: "確定",
            qx: "取消",
            sfsc: "是否刪除",
            jiazai: "拼命加載中",
            sfhj: "呼叫服务"
          },
          {
            qd: "Confirm",
            qx: "Cancel",
            sfsc: "Delete",
            jiazai: "Loading",
            sfhj: "Call service"
          },
          {
            qd: "بالتأكيد",
            qx: "يلغي",
            sfsc: "حذف أم لا",
            jiazai: "جار التحميل",
            sfhj: "خدمة الدعوة"
          },
          {
            qd: "ប្រាកដ",
            qx: "បោះបង់",
            sfsc: "លុបឬអត់",
            jiazai: "ផ្ទុកយ៉ាងខ្លាំង",
            sfhj: "សេវាហៅទូរស័ព្ទ"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "Bevestigen ",
            qx: "Annuleren",
            sfsc: "Verwijderen of niet",
            jiazai: "Bezig met laden",
            sfhj: "Medewerker"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "Conferma",
            qx: "Annulla ordine",
            sfsc: "Conferma o Annulla",
            jiazai: "Attendere",
            sfhj: "Call service"
          },
          {
            qd: "確定",
            qx: "取消",
            sfsc: "削除しますか",
            jiazai: "",
            sfhj: "御呼び"
          },
          {
            qd: "Confirmar",
            qx: "Cancelar",
            sfsc: "Confirmar exclusão?",
            jiazai: "Carregando",
            sfhj: "Chamar serviço"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "Czy na pewno",
            qx: "Anuluj",
            sfsc: "Czy go usunąć",
            jiazai: "załadowany rozpaczliwie",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "Konfirmasi",
            qx: "Batal",
            sfsc: "Hapus",
            jiazai: "",
            sfhj: "Layanan panggilan"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
          {
            qd: "determine",
            qx: "cancel",
            sfsc: "Whether or not to delete",
            jiazai: "Hard loading",
            sfhj: "Call service"
          },
        ],
      }
    },
    mounted() {
      var that = this
      window.addEventListener("scroll", this.handleScroll); //屏幕滑动触发
      this.ShopID = this.$route.query.Shopid //获取店家id
      this.tableid = this.$route.query.id //获取桌子id
      this.number = this.$route.query.Number ? this.$route.query.Number : '0'
      this.SheetID = this.$route.query.SheetID ? String(this.$route.query.SheetID) : ''
      this.PayState = (this.$route.query.PayState !== undefined && this.$route.query.PayState !== null) ? String(this.$route.query.PayState) : ''
      // PayState 路由映射：5=YabandPay / 7=Allinpay；路由 PayChannel 显式传了就用显式的
      const ps = String(this.PayState || '').trim()
      if (ps === String(this.PAYSTATE_ALLINPAY)) this.PayChannel = this.PAYCHANNEL_ALLINPAY
      else if (ps === String(this.PAYSTATE_YABAND)) this.PayChannel = this.PAYCHANNEL_YABAND
      const pc = this.$route.query.PayChannel
      if (pc && String(pc).trim().length) {
        const pcn = String(pc).trim().toLowerCase()
        if (pcn === this.PAYCHANNEL_ALLINPAY) this.PayChannel = this.PAYCHANNEL_ALLINPAY
        if (pcn === this.PAYCHANNEL_YABAND) this.PayChannel = this.PAYCHANNEL_YABAND
      }
      // 存 localStorage 兜底（通联合金台跳回时可能没带 PayState）
      try {
        if (this.ShopID) {
          const cachedChannel = String(localStorage.getItem(this.ShopID + '_pendingPayChannel') || '').trim()
          if (cachedChannel) this.PayChannel = cachedChannel
          localStorage.setItem(this.ShopID + '_pendingPayChannel', this.PayChannel)
          localStorage.setItem(this.ShopID + '_pendingPayChannelState', String(this.PayState || ''))
        }
      } catch (e) {}
      try {
        this.TradeId = String(localStorage.getItem(this.ShopID + '_pendingPayTradeId') || '')
      } catch (e) {}
      console.log(this.number)
      if (localStorage.getItem(this.$route.query.Shopid + 'pickxb'))
        this.pickxb = localStorage.getItem(this.$route.query.Shopid + 'pickxb');
      if (localStorage.getItem(this.$route.query.Shopid + 'pickxb') != null) //判断语音下标
        this.pickxb = localStorage.getItem(this.$route.query.Shopid + 'pickxb')
      console.log(this.tableid)
      console.log(this.pickxb)
	  var postdata={
	    "ShopID": this.ShopID,
	    "Amount": "",
	    "trade_id": this.TradeId,
	    "account":""
	  }
    const payQueryUrl = this.PayChannel === this.PAYCHANNEL_ALLINPAY
      ? (this.$lujin + '/api/Allinpay/PayQuery')
      : (this.$lujin + '/api/YabandPay/PayQuery')
	  this.axios.post(payQueryUrl, postdata)
		.then(ress=>{
			console.log(ress)
			setTimeout(()=>{
			  this.csh()
			},5000)
			return
			if(ress.data.Info=="paid"){
				Promise.resolve(this.handleRouteSheetState())
				  .finally(() => {
					this.csh()
					setTimeout(()=>{
					  this.csh()
					},5000)
				})
			}else{
				this.csh()
			}
		})
      

      /*if(this.$route.query.id=="Food")
        return;
      this.axios.get(this.$lujin + "/api/Default/cha_zuo?ShopID=" + this.$route.query.Shopid + "&DeskID=" + this.$route.query.id)
        .then((res) => {
          console.log(res)
          console.log(JSON.parse(res.data.data).Table[0].Desk)
          that.Desk = JSON.parse(res.data.data).Table[0].Desk
        })*/
    },
    methods: {
      getUpdateSheetStateDoneKey(sheetId) {
        const sheet = String(sheetId || '').trim()
        if (!sheet || !this.ShopID) {
          return ''
        }
        return this.ShopID + '_updateSheetStateDone_' + sheet
      },
      isUpdateSheetStateDone(sheetId) {
        const key = this.getUpdateSheetStateDoneKey(sheetId)
        if (!key) {
          return false
        }
        try {
          return !!localStorage.getItem(key)
        } catch (e) {}
        return false
      },
      markUpdateSheetStateDone(sheetId) {
        const key = this.getUpdateSheetStateDoneKey(sheetId)
        if (!key) {
          return
        }
        try {
          localStorage.setItem(key, String(Date.now()))
        } catch (e) {}
      },
      cleanupUpdateSheetStateDoneFlags() {
        if (!this.ShopID) {
          return
        }
        try {
          const prefix = this.ShopID + '_updateSheetStateDone_'
          const expireMs = 7 * 24 * 60 * 60 * 1000
          const now = Date.now()
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i)
            if (!k || k.indexOf(prefix) !== 0) {
              continue
            }
            const raw = localStorage.getItem(k)
            const t = Number(raw)
            if (!isFinite(t) || now - t > expireMs) {
              localStorage.removeItem(k)
            }
          }
        } catch (e) {}
      },
      getPendingMemberConsumeCacheKey() {
        return this.ShopID ? (this.ShopID + '_pendingMemberConsumeOrder') : 'pendingMemberConsumeOrder'
      },
      clearPendingMemberConsumeOrder() {
        try {
          localStorage.removeItem(this.getPendingMemberConsumeCacheKey())
        } catch (e) {}
      },
      clearPendingPayState() {
        if (!this.ShopID) {
          return
        }
        try {
          localStorage.removeItem(this.ShopID + '_pendingPayUrl')
          localStorage.removeItem(this.ShopID + '_pendingPayToken')
          localStorage.removeItem(this.ShopID + '_pendingPayTradeId')
          localStorage.removeItem(this.ShopID + '_pendingPayAmount')
          localStorage.removeItem(this.ShopID + '_pendingPayAccount')
          localStorage.removeItem(this.ShopID + '_pendingPaySheetID')
        } catch (e) {}
      },
      getMemberCouponCacheKey() {
        return this.ShopID ? (this.ShopID + '_memberCouponData') : 'memberCouponData'
      },
      getCouponRowKey(item, index) {
        const source = item || {}
        const base = (
          source.couponID || source.CouponID || source.CouponId ||
          source.couponSN || source.CouponSN || source.couponSn ||
          source.id || source.ID || source.sn || source.SN || ''
        )
        const text = String(base || '').trim()
        return text ? (text + '_' + index) : ('coupon_' + index)
      },
      buildMemberRequestHeaders(appKey) {
        const shopId = String(this.ShopID || '')
        const key = String(appKey || '').trim()
        const timestamp = String(Math.floor(Date.now() / 1000))
        return {
          ShopID: shopId,
          AppKey: key,
          TimeStamp: timestamp,
          Sign: this.sm3(shopId + key + timestamp)
        }
      },
      finishPendingMemberCoupons(selectedCouponKeys) {
        try {
          const raw = localStorage.getItem(this.getMemberCouponCacheKey())
          if (!raw) {
            return
          }
          const cached = JSON.parse(raw)
          if (!cached || typeof cached !== 'object') {
            return
          }
          const keys = Array.isArray(selectedCouponKeys) ? selectedCouponKeys : []
          const list = Array.isArray(cached.memberCouponList) ? cached.memberCouponList : []
          cached.memberCouponList = keys.length
            ? list.filter((item, index) => keys.indexOf(this.getCouponRowKey(item, index)) === -1)
            : list
          cached.selectedCouponKeys = []
          localStorage.setItem(this.getMemberCouponCacheKey(), JSON.stringify(cached))
        } catch (e) {}
      },
      async uploadPendingMemberConsumeOrder(sheetId) {
        let cached = null
        try {
          const raw = localStorage.getItem(this.getPendingMemberConsumeCacheKey())
          cached = raw ? JSON.parse(raw) : null
        } catch (e) {
          cached = null
        }
        if (!cached || typeof cached !== 'object') {
          return
        }
        const payload = cached.payload || null
        const appKey = String(cached.appKey || '').trim()
        if (!payload || String(payload.sheetID || '').trim() !== String(sheetId || '').trim()) {
          return
        }
        if (!appKey) {
          throw new Error('会员消费记录失败')
        }
        const headers = this.buildMemberRequestHeaders(appKey)
        const res = await this.axios.post(this.$vipurl + '/api/Upload/Add_Order', payload, {
          timeout: 10000,
          headers
        })
        const row = res && res.data ? res.data : {}
        const code = row && row.code !== undefined ? row.code : row.Code
        if (!(row.result || row.Result || Number(code) === 0)) {
          throw new Error(row.msg || row.Msg || '会员消费记录失败')
        }
        this.finishPendingMemberCoupons(cached.selectedCouponKeys)
        this.clearPendingMemberConsumeOrder()
      },
      async handleRouteSheetState() {
        const sheetId = String(this.SheetID || '').trim()
        if (!sheetId || !this.ShopID) {
          return
        }
        if (this.isUpdateSheetStateDone(sheetId)) {
          return
        }
        try {
          this.cleanupUpdateSheetStateDoneFlags()
          const res = await this.axios.post(this.$lujin + "/api/Default/UpdateSheetState", {
            SheetID: sheetId,
            ShopID: this.ShopID,
            trad_id: String(this.TradeId || '').trim()
          })
          const row = res && res.data ? res.data : {}
          const code = row && row.code !== undefined ? row.code : row.Code
          if (!(row.result || row.Result || row.state || row.State || Number(code) === 0)) {
            throw new Error(row.msg || row.Msg || '订单状态更新失败')
          }
          await this.uploadPendingMemberConsumeOrder(sheetId)
          //this.clearPendingPayState()
          this.markUpdateSheetStateDone(sheetId)
        } catch (e) {
          this.$dialog({
            title: this.ztlist[this.pickxb].wxts,
            noCancelBtn: true,
            okBtnTxt: this.ztlist[this.pickxb].qd,
            content: (e && e.message) ? e.message : '订单状态更新失败',
            onOkBtn(event) {
              this.close();
            },
          });
        }
      },
      hexiao(item){
        console.log(item)
        this.items=item
        var SheetNumber=item.SheetNumber
        var SheetNumbers=""
        for(var o in SheetNumber){
          if(SheetNumber[o]!=" ")
            SheetNumbers+=SheetNumber[o]
        }
        this.items.SheetNumbers=SheetNumbers.substring(SheetNumbers.length-4,SheetNumbers.length)
        QRCode.toCanvas(SheetNumbers+"+Z00000-",{
          width:240,
          margin:1
        },(error,canvas)=>{
          console.log(error)
          console.log(canvas)
          this.pqsb=true
          this.$refs.qrcode.innerHTML=""
          this.$refs.qrcode.appendChild(canvas)
        })
      },
      csh() {
        this.axios.get(this.$lujin + "/api/Default/Sheetlist?DeskID=" + this.$route.query.id + "&ShopID=" + this.$route
            .query.Shopid + "&Phone=" + this.$route.query.Phone)
          .then(res => {
            console.log(res)
            console.log(res.data.Data)
            var sz = res.data.Data
            if (this.SheetID) {
              const match = (Array.isArray(sz) ? sz : []).filter(item => String((item && item.SheetID) || '').trim() === this.SheetID)
              if (match.length) {
                sz = match
              }
            }
            if (sz.length == 0) {
              this.$dialog({
                title: this.ztlist[this.pickxb].wxts,
                noCancelBtn: true,
                okBtnTxt: this.ztlist[this.pickxb].qd,
                content: this.ztlist[this.pickxb].zwdd,
                onOkBtn(event) { //确定按钮点击事件
                  this.close(); //关闭对话框
                },
              });
            }
            for (var i in sz) {
              sz[i].OpTime = sz[i].OpTime.replace('T', ' ');
              sz[i].OpTime = sz[i].OpTime.slice(0, 19)
            }
            this.ddlist = sz
          })
      },
      kxdpq(SheetID) {
        var that = this
        this.$dialog({
          title: that.ztlist[that.pickxb].yjdd,
          cancelBtnTxt: that.picktan[that.pickxb].qx,
          okBtnTxt: that.picktan[that.pickxb].qd,
          onOkBtn() {
            console.log(1235451)
            this.close(); //关闭对话框
            var sbdata = new Date();
            var data = {
              ShopID: that.ShopID,
              DeskID: that.tableid,
              SheetID: SheetID,
              Number: that.number,
              Time: sbdata.getFullYear() + "-" + (sbdata.getMonth() + 1) + "-" + sbdata.getDate() + " " + sbdata
                .getHours() + ":" + sbdata.getMinutes() + ":" + sbdata.getSeconds()
            }
            that.axios.post(that.$lujin + "/api/Default/CallserviceS", data).then((res) => {
              console.log(res)
              that.csh()
            })
          },
        });
      },
      dingdan: function(SheetID) {
        this.$router.push("/qxfood?SheetID=" + SheetID + "&Shopid=" + this.ShopID);
      },
      xqesc: function() {
        this.$router.go(-1);
      },
      tableclick: function(i) {
        this.ddxb = i;
        var pos;
        if (i == 1) pos = 1;
        else if (i == 2) pos = 0;
        else if (i == 3) pos = 2;
        else pos = 3;
        this.axios.get(this.$lujin + "/api/Default/Theorder?DeskID=" + this.$route.query.id + "&ShopID=" + this.$route
          .query.Shopid + "&State=" + pos).then(res => {
          console.log(res)
          console.log(JSON.parse(res.data).Table)
          var sz = JSON.parse(res.data).Table
          for (var i in sz) {
            sz[i].OpTime = sz[i].OpTime.replace('T', ' ');
            sz[i].OpTime = sz[i].OpTime.slice(0, 19)
          }
          this.ddlist = sz
        })
      },
      sm3(input) {
        const bytes = this.sm3Utf8Bytes(String(input || ''))
        const padded = bytes.slice()
        const bitLen = bytes.length * 8
        padded.push(0x80)
        while ((padded.length % 64) !== 56) {
          padded.push(0)
        }
        const high = Math.floor(bitLen / 0x100000000)
        const low = bitLen >>> 0
        for (let i = 3; i >= 0; i--) {
          padded.push((high >>> (i * 8)) & 0xff)
        }
        for (let i = 3; i >= 0; i--) {
          padded.push((low >>> (i * 8)) & 0xff)
        }
        let v = [
          0x7380166f, 0x4914b2b9, 0x172442d7, 0xda8a0600,
          0xa96f30bc, 0x163138aa, 0xe38dee4d, 0xb0fb0e4e
        ]
        const w = new Array(68)
        const w1 = new Array(64)
        for (let offset = 0; offset < padded.length; offset += 64) {
          for (let j = 0; j < 16; j++) {
            const start = offset + j * 4
            w[j] = (((padded[start] << 24) | (padded[start + 1] << 16) | (padded[start + 2] << 8) | padded[start + 3]) >>> 0)
          }
          for (let j = 16; j < 68; j++) {
            const x = (w[j - 16] ^ w[j - 9] ^ this.sm3Rotl(w[j - 3], 15)) >>> 0
            w[j] = (this.sm3P1(x) ^ this.sm3Rotl(w[j - 13], 7) ^ w[j - 6]) >>> 0
          }
          for (let j = 0; j < 64; j++) {
            w1[j] = (w[j] ^ w[j + 4]) >>> 0
          }
          let a = v[0]
          let b = v[1]
          let c = v[2]
          let d = v[3]
          let e = v[4]
          let f = v[5]
          let g = v[6]
          let h = v[7]
          for (let j = 0; j < 64; j++) {
            const tj = j < 16 ? 0x79cc4519 : 0x7a879d8a
            const ss1 = this.sm3Rotl(((this.sm3Rotl(a, 12) + e + this.sm3Rotl(tj, j)) >>> 0), 7)
            const ss2 = (ss1 ^ this.sm3Rotl(a, 12)) >>> 0
            const tt1 = ((this.sm3FF(a, b, c, j) + d + ss2 + w1[j]) >>> 0)
            const tt2 = ((this.sm3GG(e, f, g, j) + h + ss1 + w[j]) >>> 0)
            d = c
            c = this.sm3Rotl(b, 9)
            b = a
            a = tt1
            h = g
            g = this.sm3Rotl(f, 19)
            f = e
            e = this.sm3P0(tt2)
          }
          v = [
            (v[0] ^ a) >>> 0,
            (v[1] ^ b) >>> 0,
            (v[2] ^ c) >>> 0,
            (v[3] ^ d) >>> 0,
            (v[4] ^ e) >>> 0,
            (v[5] ^ f) >>> 0,
            (v[6] ^ g) >>> 0,
            (v[7] ^ h) >>> 0
          ]
        }
        return v.map(n => ('00000000' + (n >>> 0).toString(16)).slice(-8)).join('')
      },
      sm3Utf8Bytes(str) {
        const bytes = []
        for (let i = 0; i < str.length; i++) {
          let code = str.charCodeAt(i)
          if (code >= 0xd800 && code <= 0xdbff && i + 1 < str.length) {
            const next = str.charCodeAt(i + 1)
            if (next >= 0xdc00 && next <= 0xdfff) {
              code = ((code - 0xd800) << 10) + (next - 0xdc00) + 0x10000
              i++
            }
          }
          if (code <= 0x7f) {
            bytes.push(code)
          } else if (code <= 0x7ff) {
            bytes.push(0xc0 | (code >>> 6))
            bytes.push(0x80 | (code & 0x3f))
          } else if (code <= 0xffff) {
            bytes.push(0xe0 | (code >>> 12))
            bytes.push(0x80 | ((code >>> 6) & 0x3f))
            bytes.push(0x80 | (code & 0x3f))
          } else {
            bytes.push(0xf0 | (code >>> 18))
            bytes.push(0x80 | ((code >>> 12) & 0x3f))
            bytes.push(0x80 | ((code >>> 6) & 0x3f))
            bytes.push(0x80 | (code & 0x3f))
          }
        }
        return bytes
      },
      sm3Rotl(x, n) {
        const shift = n % 32
        return ((x << shift) | (x >>> (32 - shift))) >>> 0
      },
      sm3P0(x) {
        return (x ^ this.sm3Rotl(x, 9) ^ this.sm3Rotl(x, 17)) >>> 0
      },
      sm3P1(x) {
        return (x ^ this.sm3Rotl(x, 15) ^ this.sm3Rotl(x, 23)) >>> 0
      },
      sm3FF(x, y, z, j) {
        return (j < 16 ? (x ^ y ^ z) : ((x & y) | (x & z) | (y & z))) >>> 0
      },
      sm3GG(x, y, z, j) {
        return (j < 16 ? (x ^ y ^ z) : ((x & y) | ((~x) & z))) >>> 0
      },
      handleScroll() {
        return;
      }
    }
  }
</script>

<style scoped>
  .dmbt {
    background: #fff;
    border: none;
    border: 1px solid #000;
    border-radius: .1rem;
    float: right;
    margin-right: .35rem;
    padding: .08rem .08rem;
    font-size:0.28rem;
  }

  .clear::after {
    content: ;
    clear: both;
  }

  .dingdan {
    background: #fff;
    position: fixed;
    top: .91rem;
    left: 0;
    right: 0;
  }

  .dingdan ul {
    display: flex;
  }

  .dingdan ul li {
    font-size: .32rem;
    width: 33.3%;
    padding: .1rem;
  }

  .dingdan ul li.on {
    color: orange;
    border-bottom: 1px solid orange;
  }

  .ddlist {
    background: #f7f7f7;
    float: left;
    width: 100%;
    height: 100%;
    padding-top: 1.64rem;
  }

  .ddlist>div {
    width: 90%;
    margin: .3rem auto 0 auto;
    background: #fff;
    border-radius: .1rem;
  }

  .ddlist>div .top p {
    height: .4rem;
    margin-top: .2rem;
    border-radius: .4rem;
    padding: 0 .1rem;
  }

  .ddlist>div .top p.on1 {
    border: 1px solid chartreuse;
    color: chartreuse;
  }

  .ddlist>div .top p.on2 {
    border: 1px solid orange;
    color: orange;
  }

  .ddlist>div .top p.on3 {
    border: 1px solid #999;
    color: #999;
  }

  .ddlist>div .top span {
    line-height: .8rem;
  }

  .ddlist>div .top {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    height: .8rem;
    border-bottom: 1px solid #eee;
  }

  .ddlist div span,
  .ddlist div p {
    font-size: .28rem;
    display: block;
  }

  .butlist {
    display: flex;
    line-height: .8rem;
    height: .8rem;
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
  }

  .butlist span {
    font-size: .32rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/dd.vue